import { render, staticRenderFns } from "./OrderVerify.vue?vue&type=template&id=693b96c6&scoped=true"
import script from "./OrderVerify.vue?vue&type=script&lang=js"
export * from "./OrderVerify.vue?vue&type=script&lang=js"
import style0 from "./OrderVerify.vue?vue&type=style&index=0&id=693b96c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b96c6",
  null
  
)

export default component.exports